import {
  StatesMachine,
  StatesMachineProps
} from "./classes/state-machine/state-machine";
import { Toast } from "components/toast";
import { apiHigienizacaoJWT } from "api/api-higienizacao";
import { createLinkAndDownload } from "utils/create-link-and-download";
import { apiJWT } from "api/api-jwt";
import api from "api/api";
import { MailingTableRow } from "components/mailing-components/mailing-table";

export interface MailingDataProps {
  id: number;
  dataCriacao: number;
  convenio: string;
  subConvenio: string | null;
  status: string;
  origem: string;
  name: string;
  qtdSolicitada: number | null;
  qtdGerada: number | null;
  filtrosJson: string | null;
  currentPipelineOrdem: number | null;
  tipoOperacao: string;
  bancosFrom: any[];
  bancosTo: any[];
  digitacaoLote: boolean;
  userId: number;
  customerId: number;
}

export class PipelineEndpoints {
  public static getBancoOperacaoOptions = (mailingId: number) => {
    return async () => {
      try {
        const { data } = await api.get<string[]>(
          `/pipeline/${mailingId}/bancos-disponiveis-refin`
        );
        return data.map((banco) => ({ name: banco, value: banco }));
      } catch (e: any) {
        const errorMessage = e?.response?.data?.message;
        Toast({
          title: "Erro ao obter opções de Banco Operação",
          description: errorMessage,
          status: "error"
        });
        return [];
      }
    };
  };

  public static getBanksOptions = async (mailingId: number) => {
    const { data } = await api.get(`/datafast/mailing/${mailingId}`);
    return data.map((key: string) => ({ name: key, value: key }));
  };

  public static async savePipelineData(
    pipelineData: StatesMachine,
    mailingData: Partial<MailingTableRow>,
    midiaFileWpp?: File
  ) {
    const formData = new FormData();
    const mailingName = mailingData.name;
    const pipelineDataJson = JSON.stringify({
      ...pipelineData.formatToSend(),
      mailingName
    });
    formData.append(
      "data",
      new Blob([pipelineDataJson], {
        type: "application/json"
      })
    );
    if (midiaFileWpp) {
      formData.append("midiaFilesWpp", midiaFileWpp);
    }

    const { data } = await apiHigienizacaoJWT.post<StatesMachineProps>(
      `/higienizacao-pipeline/pipeline-new`,
      formData
    );

    return new StatesMachine(data);
  }

  public static async getMailingData(id: number) {
    const { data } = await api.get<MailingDataProps>(`/mailings/${id}`);

    return data;
  }

  public static async getPipelineData(
    id: string | null
  ): Promise<StatesMachine> {
    if (!id) {
      Toast({ title: "Pipeline ID inválido", status: "error" });
      throw new Error("Pipeline ID inválido");
    }

    const response = await apiHigienizacaoJWT.get(
      `/higienizacao-pipeline/pipeline-new/mailing/${id}`
    );

    return new StatesMachine(response.data);
  }

  public static async downloadValidationErrorCSV(
    pipelineId: number,
    errorType: "ENDERECO" | "DADOS_BANCARIOS"
  ) {
    const { data } = await apiHigienizacaoJWT.get<string>(
      `/higienizacao-pipeline/pipeline-new/${pipelineId}/typing/errors/download`,
      { params: { errorType } }
    );

    return new File(
      [data],
      `digitacao-erros-${errorType.toLowerCase()}-pipeline-${pipelineId}.csv`,
      { type: "text/csv;charset=utf-8;" }
    );
  }

  public static async downloadPipelineCSV(mailingId: string | number) {
    try {
      const response = await apiJWT.get(
        `/mailing-lead/pipeline/${mailingId}/download`
      );

      const csvString = response.data;
      const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
      createLinkAndDownload(blob, `pipeline_${mailingId}.csv`);

      Toast({ title: "CSV baixado com sucesso", status: "success" });
    } catch (e) {
      Toast({ title: "Erro ao baixar CSV", status: "error" });
      console.error(e);
    }
  }

  public static async getInitModal(): Promise<{ lida: boolean }> {
    const response = await apiHigienizacaoJWT.get<{ lida: boolean }>(
      "/pipeline-new/init-modal"
    );
    return response.data;
  }
}
